// ProductType Vuex

import state from './shortageStates.js'
import * as getters from './shortageGetters.js'
import * as mutations from './shortageMutations.js'
import * as actions from './shortageActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
